module.exports = __webpack_public_path__ + "static/state-of-the-earth-catalogue-cover-0a26f81705c1200bbdd3c7e28dfc5764.jpg";